'use client';

import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import AnimatedTitle from '@/components/AnimatedTitle';
import ClutchWidget from '@/components/ClutchWidget';
import { LazyDither } from '@/components/Dither';

import styles from './HeroSection.module.scss';

const HeroSection = () => {
  const t = useTranslations('home.heroSection');

  return (
    <Container
      component="section"
      maxWidth={false}
      disableGutters
      classes={{ root: styles.root }}
      className={styles.container}
    >
      <Box className={styles.blur} />
      <Container component="div" maxWidth="xl" className={styles.content}>
        <AnimatedTitle title={t('title')} className={styles.title} />
        <Typography variant="body1" className={styles.description}>
          {t('description')}
        </Typography>
        <Stack direction="row" justifyContent={{ xs: 'flex-start', md: 'flex-end' }} mt={{ xs: 8, md: 2 }}>
          <ClutchWidget />
        </Stack>
      </Container>
      <LazyDither
        className={styles.bgImageContainer}
        density={75}
        size={2.5}
        brightnessFlickerSpeed={0.005}
        fadeInDuration={0.8}
        src="/images/hero/default-bg.webp"
      />
      <Box className={styles.bgImageContainerMobile}>
        <Image src="/images/hero/default-bg-dithered.webp" alt="Hero" fill style={{ objectFit: 'cover' }} />
      </Box>
    </Container>
  );
};

export default HeroSection;
